/* Moment.js is 2.8mb. Let's not bring it in just for this. */ 
class MiscUtil {
    static secsToHHMMSS(secs) {
        let hours = Math.floor(secs / 3600);
        secs = secs - (hours * 3600);
        let mins = Math.floor(secs / 60);
        secs = secs - (mins * 60);
        if (hours < 1) {
            return mins.toString().padStart(2,"0") + ":" + secs.toString().padStart(2,"0")
        } else {
            return hours.toString().padStart(2,"0") + ":" + mins.toString().padStart(2,"0") + ":" + secs.toString().padStart(2,"0")
        }
    }

}
export default MiscUtil;